import React from "react";
import Main from "../../components/layout/Main";
const PrivateRoute = ({ children }) => {
  return (
    <>
      <Main>{children}</Main>
    </>
  );
};

export default PrivateRoute;
